module.exports = __webpack_public_path__ + "img/agency-slide-03.2247e885.jpg";